	/**
	 * @description
	 *  Modelo del Tipo de Invoice de un pedido.
	 *
	 * @see gigot-backend/Models/Orders/Order.cs
	 */

export enum OrderInvoiceTypeLabel {
	CF = 'CONSUMIDOR FINAL',
	EX = 'EXENTO',
	MT = 'MONOTRIBUTO',
	RI = 'RESPONSABLE INSCRIPTO',
	NC = 'SUJETO NO CATEGORIZADO'
}
